/* AVELUNE — comportamiento propio (vanilla) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (e) { e.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('mt-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initParallax() {
    var items = document.querySelectorAll('[data-mt-parallax]');
    if (!items.length || reduce || window.innerWidth < 750) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var host = el.parentElement.getBoundingClientRect();
        if (host.bottom < 0 || host.top > window.innerHeight) return;
        var k = parseFloat(el.getAttribute('data-mt-parallax')) || 0.15;
        el.style.setProperty('--mt-py', (-host.top * k).toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function initCount() {
    var els = document.querySelectorAll('[data-mt-count]');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-mt-count').replace(',', '.'));
      var dec = (el.getAttribute('data-mt-count').split(/[.,]/)[1] || '').length;
      if (isNaN(target) || reduce) return;
      var start = null;
      function step(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / 1400, 1);
        var v = target * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec).replace('.', ',');
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initGallery() {
    document.querySelectorAll('[data-mt-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-mt-main]');
      if (!main) return;
      g.querySelectorAll('[data-mt-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          main.src = btn.getAttribute('data-src');
          main.removeAttribute('srcset');
          g.querySelectorAll('[data-mt-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function initQty() {
    document.querySelectorAll('[data-mt-qty]').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.getAttribute('data-dir') === '+' ? 1 : -1;
          input.value = Math.max(1, v);
        });
      });
    });
  }

  function initVideo() {
    document.querySelectorAll('[data-mt-video]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = btn.getAttribute('data-mt-video');
        f.title = btn.getAttribute('aria-label') || 'Vídeo';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        btn.parentNode.replaceChild(f, btn);
      });
    });
  }

  function initTiers() {
    document.querySelectorAll('[data-mt-product]').forEach(function (root) {
      var tiers = root.querySelector('[data-mt-tiers]');
      var qtyInput = root.querySelector('[data-mt-qty] input');
      if (!tiers || !qtyInput) return;
      function mark(v) {
        tiers.querySelectorAll('.mt-tier').forEach(function (l) {
          var r = l.querySelector('input');
          var on = r.value === String(v);
          r.checked = on;
          l.classList.toggle('is-active', on);
        });
      }
      tiers.querySelectorAll('input').forEach(function (r) {
        r.addEventListener('change', function () { qtyInput.value = r.value; mark(r.value); });
      });
      root.querySelectorAll('[data-mt-qty] button').forEach(function (b) {
        b.addEventListener('click', function () { setTimeout(function () { mark(qtyInput.value); }, 0); });
      });
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-mt-product]').forEach(function (root) {
      var json = root.querySelector('script[data-mt-variants]');
      if (!json) return;
      var variants = JSON.parse(json.textContent);
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-mt-price]');
      var btn = root.querySelector('[data-mt-add]');
      var labelAdd = btn ? btn.getAttribute('data-label-add') : '';
      var labelSold = btn ? btn.getAttribute('data-label-sold') : '';
      function update() {
        var chosen = [];
        root.querySelectorAll('.mt-options fieldset').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          chosen.push(c ? c.value : null);
        });
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (!match) return;
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
        var cmp = root.querySelector('[data-mt-compare]');
        var pct = root.querySelector('[data-mt-pct]');
        if (cmp) {
          cmp.textContent = match.compare;
          cmp.hidden = !match.compare;
          if (pct) {
            var num = function (s) { return parseFloat(String(s).replace(/[^0-9.,]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.')); };
            var a = num(match.compare), b = num(match.price);
            pct.hidden = !(a > b);
            if (a > b) pct.textContent = '-' + Math.round((a - b) * 100 / a) + '%';
          }
        }
        if (match.image) {
          var main = root.querySelector('[data-mt-main]');
          if (main) {
            main.src = match.image; main.removeAttribute('srcset');
            root.querySelectorAll('[data-mt-thumb]').forEach(function (t) {
              t.setAttribute('aria-current', t.getAttribute('data-src') === match.image ? 'true' : 'false');
            });
          }
        }
        var buyNow = root.querySelector('[data-mt-buynow]');
        if (buyNow) buyNow.disabled = !match.available;
        if (btn) {
          btn.disabled = !match.available;
          btn.querySelector('span').textContent = match.available ? labelAdd : labelSold;
        }
      }
      root.querySelectorAll('.mt-options input').forEach(function (i) { i.addEventListener('change', update); });
    });
  }

  function initTilt() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('[data-mt-tilt]').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * 5).toFixed(2) + 'deg) rotateX(' + (-y * 5).toFixed(2) + 'deg) translateY(-4px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  function init() {
    initReveal(); initParallax(); initCount(); initGallery(); initQty(); initVideo(); initTiers(); initVariants(); initTilt();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
